export const REFERER_WHITELIST = ['localhost:3000', 'vercel.app', 'djoglobal.de']
export const USER_TOKEN = process.env.NODE_ENV === 'production' ? '__Host-user-token' : 'user-token'
export const JWT_SECRET_KEY = process.env.JWT_SECRET_KEY!
export const VALUE_SEPARATOR = ','
export const FILTER_SEPARATOR = '|'
export const KEY_SEPARATOR = ':'
